import { useEffect, useState } from 'react'
import { ALL_FEATURES_OFF, type FinanceFeatureMap } from '@/lib/finance'
import { financeSummaryService } from '@/services/financeSummaryService'

let cached: FinanceFeatureMap | null = null
let inflight: Promise<FinanceFeatureMap> | null = null

function load(): Promise<FinanceFeatureMap> {
  if (cached) return Promise.resolve(cached)
  if (!inflight) {
    inflight = financeSummaryService.features()
      .then((map) => (cached = { ...ALL_FEATURES_OFF, ...map }))
      .catch(() => ALL_FEATURES_OFF)
      .finally(() => { inflight = null })
  }
  return inflight
}

/** Só para testes. */
export function resetFinanceFeaturesCache(): void {
  cached = null
  inflight = null
}

/**
 * Partes do financeiro ligadas no servidor (BTG, boleto, faturas, transferências,
 * carnê). Uma consulta por sessão; enquanto carrega ou se falhar, tudo desligado.
 */
export function useFinanceFeatures(): { features: FinanceFeatureMap; loading: boolean } {
  const [features, setFeatures] = useState<FinanceFeatureMap>(cached ?? ALL_FEATURES_OFF)
  const [loading, setLoading] = useState(!cached)
  useEffect(() => {
    let alive = true
    load().then((map) => {
      if (!alive) return
      setFeatures(map)
      setLoading(false)
    })
    return () => { alive = false }
  }, [])
  return { features, loading }
}
